import AbstractDataAttributeBehaviour from './abstract-data-attribute-behaviour';
import APIManager from '../services/api-manager';

export default class RecommendBehaviour extends AbstractDataAttributeBehaviour {
    APIManager = new APIManager();

    getContainerSelector()
    {
        return '[data-recommend]';
    }

    /**
     * @param inputElement <HTMLElement>
     * @param eventsOnly <Bool>
     */
    initContainer(inputElement, eventsOnly = false)
    {
        //Handle elements on click
         if (inputElement.getAttribute('id') === 'text-link-ref') {
             inputElement.addEventListener('click', (e) => {
                 e.preventDefault();
                 this.sendRafEmail();
             });
         }
    }

    sendRafEmail(){
        // just hit the url, all client data needed is handled in rafcontroller.
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                var returnedObject = JSON.parse(this.responseText);
                if(returnedObject.Success == true) {
                    //document.getElementById('raf_feedback').textContent = 'Email sent, please check your emails';
                    window.location.replace("/my-rol/recommend");
                } else {
                    //document.getElementById('raf_feedback').textContent = 'Problem sending email';
                }

            }
        };
        xhttp.open("GET", "/raf_email", true);
        xhttp.send();


    }
}

